import type { Action } from 'src/types';

export enum Actions {
  TIPS_UPDATE_SUCCESS = 'TIPS_UPDATE_SUCCESS',
  TIPS_UPDATE_FAILURE = 'TIPS_UPDATE_FAILURE',
}

export type TipsAction =
  | Action<Actions.TIPS_UPDATE_SUCCESS>
  | (Action<Actions.TIPS_UPDATE_FAILURE> & {
      payload: Error;
    });
